module.exports = __webpack_public_path__ + "static/img/5.7cf3286.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/eventBanner/5.jpg
// module id = 8ZNX
// module chunks = 9